import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

export interface IAutoFillUploadFile {
    contract_name: string,
    contract_no: string,
    document_type:{
        id: number,
        user_id: number,
        workspace_id: number,
        document_type: string,
        is_default: boolean,
        created_at: string,
        updated_at: string,
        selector_for: number
    },
    category:{
        category_name: string,
        user_id: number,
        workspace_id: number,
        updated_at: string,
        created_at: string,
        id: number
    },
    organization:{
        id: number,
        user_id: number,
        workspace_id: number,
        name: string,
        register_no: string,
        address: string,
        zipcode: string,
        city: string,
        phone: string,
        organization_image: string,
        created_at: string,
        updated_at: string
    },
    period:{
        auto_date_renew: string;
        auto_renew: boolean;
        contract_length: string;
        contract_length_renew: string;
        created_at: string;
        end_date: string;
        last_auto_date_renew: null;
        notice: string;
        notice_date: string;
        notice_date_renew: string;
        notice_period: string;
        notice_period_renew: string;
        notice_renew: string;
        other_length_period_renew: null;
        other_length_renew: null;
        start_date: string;
        updated_at: string;
    },
    cost:{
        conversion_date: string;
        conversion_rate: string;
        cost_amount: number | string;
        cost_converted_amount: number;
        cost_currency: string;
        cost_duration: number;
        cost_period: string;
        cost_startup: number | string;
        created_at: string;
        document_type_id: number;
        updated_at: string;
    },
    revenue:{
        conversion_date: string;
        conversion_rate: string;
        created_at: string;
        document_type_id: number;
        revenue_amount: number;
        revenue_converted_amount: number;
        revenue_currency: string;
        revenue_duration: number;
        revenue_period: string;
        revenue_startup: string;
        updated_at: string;
    },
    recipient:{
        address?: string;
        city?: string;
        created_at?: string;
        email: string;
        firstname: string;
        id: number;
        lastname?: string;
        organization_id?: number;
        persnol_no?: string;
        phone_no?: string;
        profile_image?: string;
        updated_at?: string;
        user_id: number;
        workspace_id: number;
        zipcode?: string;
    }[],
    meta_data:{
        [api_attribute: string]: string | number | boolean | string[] | number[] | boolean[] | []
    }
}


@Injectable({
  providedIn: 'root'
})
export class AiCcImportService {
    
  constructor(private _http:HttpClient) { }
    
    public autofillUploadFile(file:File, document_type_id: number):Observable<IAutoFillUploadFile>{
        const formData = new FormData();
        formData.append('file', file);
        formData.append('document_type_id', document_type_id?.toString());

     return this._http.post<IAutoFillUploadFile>('imports/contracts/pdf/direct-import', formData);
    }
}
